import axios from "axios";
import { __constants } from "../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getJobsController = async (param) => {
    let query = "";
    if (param.page) { query += `&page=${param.page}` };
    if (param.limit) { query += `&limit=${param.limit}` };
    if (param.status) { query += `&status=${param.status}` };
    if (param.fRole) { query += `&fRole=${param.fRole}` };
    if (param.startDate) { query += `&startDate=${param.startDate}` };
    if (param.endDate) { query += `&endDate=${param.endDate}` };
    if (param.type) { query += `&type=${param.type}` };
    if (param.durationType) { query += `&durationType=${param.durationType}` };
    if (param.stripeDisabled !== undefined && param.stripeDisabled !== "") { query += `&stripeDisabled=${param.stripeDisabled}` };
  
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/jobs-listing?limit=${__constants.listingLimit}${query}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getJobsController >> ", err.message);
        return err.response
    }
}

export const getJobsAppliersController = async (jobId) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/applied-job/${jobId}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getJobsAppliersController >> ", err.message);
        return err.response
    }
}

export const getJobsDetailController = async (jobId) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/job/${jobId}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getJobsDetailController >> ", err.message);
        return err.response
    }
}

export const getBookingDetail = async (applicationId) => { /* Get Booking Details */
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/booking-info/${applicationId}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getJobsDetailController >> ", err.message);
        return err.response
    }
}

export const getInvoice = async (applicationId) => { /* Get Invoice */
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/booking/invoice/${applicationId}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getJobsDetailController >> ", err.message);
        return err.response
    }
}
